import styled from 'styled-components';
import { screenXsMax, screenSmMin, spacer8 } from '@spotify-internal/encore-foundation';
import { fontWeightBold, typeStyleBody2 } from "../../styles";
export default styled.div.withConfig({
  displayName: "LabelGroup",
  componentId: "l4md8f-0"
})(["", ";align-items:center;display:flex;font-weight:", ";width:100%;@media (max-width:", "){justify-content:space-between;}@media (min-width:", "){padding-bottom:", ";}"], typeStyleBody2(), fontWeightBold, screenXsMax, screenSmMin, spacer8);